// jQuery wrapper
(function ($) {

    /**
     ** Document ready
     **/
    $(document).ready(function () {

        $('body').addClass('active');


        // Smooth Scroll
        $('a.smooth-scroll, button.smooth-scroll').on('click', function (event) {
            event.preventDefault();
            var target = $(this).data('target');
            var headerHeight = $('#site-header').outerHeight();
            var scrollPosition = $(target).offset().top - (headerHeight);
            // var scrollPosition = $(target).offset().top;

            // console.log(headerHeight);

            $('html').animate({
                scrollTop: scrollPosition
            }, 1000);
        });


        // Accordion list (FAQ setc.)
        if ($('.accordion-list').length > 0) {
            $('.accordion-list .answer:not(.active)').hide();
            // var allPanels = $('.accordion-list .answer');

            $('.accordion-list .accordion-toggle').click(function () {
                // var targetParent = $(this).data('parent');
                var target = $(this).data('target');

                // console.log(targetParent);

                if ($(target).hasClass('active')) {
                    $(this).removeClass('current');
                    $(target).removeClass('active').slideUp(250);

                } else {
                    // $('.accordion-list .accordion-toggle').removeClass('current');
                    // $('.accordion-list .answer').removeClass('active').slideUp(250);

                    $(this).addClass('current');
                    $(target).addClass('active').slideDown(250);
                }

                // Prevent default 'link' behaviour
                return false;
            });
        }


        /***
         * Menus
         ***/
        // Hamburger & Mobile Menu
        $('.hamburger').click(function () {
            if ($(this).hasClass('is-active')) {
                $(this).removeClass('is-active');
                $('.hamburger label').val('Close');
                $('body').removeClass('mobile-menu-open');
            } else {
                $(this).toggleClass('is-active');
                $('body').addClass('mobile-menu-open');
            }
        });

        // Desktop Menu
        $('#header-menu .hasSub > a').click(function (e) {
            e.preventDefault();

            var target = $(this).attr('href');

            // If target submenu already open
            if ($(target).hasClass('open')) {
                $('body').removeClass('menu-open');
                $('#header-menu .hasSub > a').removeClass('current');
                $('#dt-submenus .submenu').removeClass('open');

            } else {
                $('body').addClass('menu-open');
                $('#header-menu .hasSub > a').removeClass('current');
                $(this).addClass('current');
                $('#dt-submenus .submenu').removeClass('open');
                $(target).addClass('open');
            }
        });


        // News filter
        if ($('#filter-column').length > 0) {
            // Dropdowns Select2
            $('#cat').select2({
                minimumResultsForSearch: Infinity,
                allowClear: false,
                width: '100%',
                placeholder: 'Category',
                //dropdownCssClass: 'filter_dropdown',
            });
            $('#archives-dropdown-2').select2({
                minimumResultsForSearch: Infinity,
                allowClear: false,
                width: '100%',
                placeholder: 'Archive',
                //dropdownCssClass: 'filter_dropdown',
            });
        }


        // Treatments Filter
        if ($('.mobile-nav-trigger').length > 0) {
            $('.mobile-nav-trigger').on('click', function () {
                $('.mobile-nav-trigger').toggleClass('active');
                $('.dropdown-items-categories').toggleClass('visible');
            });
        }

        // Gallery & Videos Filter
        if ($('.filter-wrapper').length > 0) {
            $('.filter-wrapper span').on('click', function () {
                $('.filter-wrapper span').removeClass('active');
                $(this).addClass('active');

                let selected = $(this).attr('value');

                if (selected === 'all') {
                    $('.single-gallery-item').removeClass('hide');
                    return;
                }

                $('.single-gallery-item').each(function () {
                    let terms = $(this).data('gallery-categories');

                    if (terms && terms.includes(selected)) {
                        $(this).removeClass('hide');
                    } else {
                        $(this).addClass('hide');
                    }
                });
            });
        }


        // Video modal toggle open/closed
        $('.video-toggle').click(function () {
            var target = $(this).data('target');
            $(target).modal('toggle');
        });
        // Video modal - Empty player on close
        $('.close-video').click(function () {
            $('.video-container').empty();
        });


        // Video Categories
        $('#video_category').on('change', function () {
            const selected = $(this).val();
            const $videos = $('.patient-video-item');
            const $sectionTop = $('.patient-videos'); // <--- adjust selector to your section

            // Filter logic
            if (!selected) {
                $videos.show();
            } else {

                $videos.hide();

                $videos.filter(function () {
                    const cats = $(this).data('category');
                    return cats && cats.indexOf(selected) !== -1;
                }).show();
            }

            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: $sectionTop.offset().top - 80
                }, 300);
            }, 50);
        });


        /***
         * Carousels
         ***/
        // Procedure Categories
        let proceduresCarousel = document.querySelector('#procedures .procedures-carousel');
        if (proceduresCarousel != null) {
            $(proceduresCarousel).flickity({
                // options
                cellAlign: 'left',
                contain: true,
                freeScroll: true,
                wrapAround: false,
                pageDots: false,
                prevNextButtons: false,
                imagesLoaded: true
            });

            // Previous
            $('#procedures .procedures-prev').on('click', function () {
                $(proceduresCarousel).flickity('previous');
            });

            // Next
            $('#procedures .procedures-next').on('click', function () {
                $(proceduresCarousel).flickity('next');

            });
        }

        // Team
        let teamCarousel = document.querySelector('#team .team-carousel');
        if (teamCarousel != null) {
            $(teamCarousel).flickity({
                // options
                cellAlign: 'left',
                contain: true,
                freeScroll: true,
                wrapAround: false,
                pageDots: false,
                prevNextButtons: false,
                imagesLoaded: true
            });

            // Previous
            $('.team-prev').on('click', function () {
                $(teamCarousel).flickity('previous');
            });

            // Next
            $('.team-next').on('click', function () {
                $(teamCarousel).flickity('next');

            });
        }

        // Testimonials
        let testimonialCarousel = document.querySelector('#testimonials .testimonials-carousel');
        if (testimonialCarousel != null) {
            $(testimonialCarousel).flickity({
                // options
                cellAlign: 'left',
                contain: false,
                freeScroll: false,
                wrapAround: true,
                fade: true,
                pageDots: false,
                prevNextButtons: false,
                imagesLoaded: true,
            });

            // Previous
            $('.testimonials-prev').on('click', function () {
                $(testimonialCarousel).flickity('previous');
            });

            // Next
            $('.testimonials-next').on('click', function () {
                $(testimonialCarousel).flickity('next');
            });
        }

        // Feedback
        let feedbackCarousel = document.querySelector('#feedback .feedback-carousel');
        if (feedbackCarousel != null) {
            $(feedbackCarousel).flickity({
                // options
                cellAlign: 'left',
                contain: true,
                freeScroll: false,
                wrapAround: true,
                fade: true,
                pageDots: false,
                prevNextButtons: false,
                imagesLoaded: true,
            });

            // Previous
            $('.feedback-prev').on('click', function () {
                $(feedbackCarousel).flickity('previous');
            });

            // Next
            $('.feedback-next').on('click', function () {
                $(feedbackCarousel).flickity('next');
            });
        }

        // Related Procedures
        let relatedProcCarousel = document.querySelector('#related-procedures .procedures-carousel');
        if (relatedProcCarousel != null) {
            $(relatedProcCarousel).flickity({
                // options
                cellAlign: 'left',
                contain: true,
                freeScroll: true,
                wrapAround: false,
                pageDots: false,
                prevNextButtons: false,
                imagesLoaded: true
            });

            // Previous
            $('#related-procedures .procedures-prev').on('click', function () {
                $(relatedProcCarousel).flickity('previous');
            });

            // Next
            $('#related-procedures .procedures-next').on('click', function () {
                $(relatedProcCarousel).flickity('next');
            });
        }


        // Team Accreditation Logos
        let teamAccreditationCarousel = document.querySelector('.team-accreditation-carousel');
        if (teamAccreditationCarousel != null) {
            $(teamAccreditationCarousel).flickity({
                // options
                cellAlign: 'center',
                contain: true,
                freeScroll: true,
                wrapAround: false,
                pageDots: false,
                prevNextButtons: false,
                imagesLoaded: true
            });
        }

        // Related Conditions
        let relatedCondCarousel = document.querySelector('#related-conditions .conditions-carousel');
        if (relatedCondCarousel != null) {
            $(relatedCondCarousel).flickity({
                // options
                cellAlign: 'left',
                contain: true,
                freeScroll: true,
                wrapAround: false,
                pageDots: false,
                prevNextButtons: false,
                imagesLoaded: true
            });

            // Previous
            $('#related-conditions .conditions-prev').on('click', function () {
                $(relatedCondCarousel).flickity('previous');
            });

            // Next
            $('#related-conditions .conditions-next').on('click', function () {
                $(relatedCondCarousel).flickity('next');
            });
        }

        // Results / Before & After
        let resultsCarousel = document.querySelector('#results .results-carousel');
        if (resultsCarousel != null) {
            $(resultsCarousel).flickity({
                // options
                cellAlign: 'left',
                contain: true,
                freeScroll: true,
                wrapAround: true,
                pageDots: false,
                prevNextButtons: false,
                imagesLoaded: true
            });

            // Previous
            $('#results .results-prev').on('click', function () {
                $(resultsCarousel).flickity('previous');
            });

            // Next
            $('#results .results-next').on('click', function () {
                $(resultsCarousel).flickity('next');
            });
        }

        // Downloads. - Healthcare Professionals / Referrals
        let downloadsCarousel = document.querySelector('#downloads .downloads-carousel');
        if (downloadsCarousel != null) {
            $(downloadsCarousel).flickity({
                // options
                cellAlign: 'left',
                contain: true,
                freeScroll: true,
                wrapAround: true,
                pageDots: false,
                prevNextButtons: false,
                imagesLoaded: true
            });

            // Previous
            $('#downloads .downloads-prev').on('click', function () {
                $(downloadsCarousel).flickity('previous');
            });

            // Next
            $('#downloads .downloads-next').on('click', function () {
                $(downloadsCarousel).flickity('next');
            });
        }

        // Downloads - Treatments
        let treatmentDownloadsCarousel = document.querySelector('#treatment-downloads .downloads-carousel');
        if (treatmentDownloadsCarousel != null) {
            $(treatmentDownloadsCarousel).flickity({
                // options
                cellAlign: 'left',
                contain: true,
                freeScroll: true,
                wrapAround: true,
                pageDots: false,
                prevNextButtons: false,
                imagesLoaded: true
            });

            // Previous
            $('#treatment-downloads .downloads-prev').on('click', function () {
                $(treatmentDownloadsCarousel).flickity('previous');
            });

            // Next
            $('#treatment-downloads .downloads-next').on('click', function () {
                $(treatmentDownloadsCarousel).flickity('next');
            });
        }

        // Procedure Categories
        let relatedPostCarousel = document.querySelector('.related-post-carousel');
        if (relatedPostCarousel != null) {
            $(relatedPostCarousel).flickity({
                // options
                cellAlign: 'left',
                contain: true,
                freeScroll: true,
                wrapAround: false,
                pageDots: false,
                prevNextButtons: false,
                imagesLoaded: true
            });

            // Previous
            $('.related-post-prev').on('click', function () {
                $(relatedPostCarousel).flickity('previous');
            });

            // Next
            $('.related-post-next').on('click', function () {
                $(relatedPostCarousel).flickity('next');

            });
        }

        // Insurers Carousel
        let insurersCarousel = document.querySelector('.insurers-carousel');
        if (insurersCarousel != null) {
            $(insurersCarousel).flickity({
                cellAlign: 'left',
                contain: true,
                freeScroll: true,
                wrapAround: false,
                pageDots: false,
                prevNextButtons: false,
                imagesLoaded: true
            });

            // Previous
            $('.insurers-prev').on('click', function () {
                $(insurersCarousel).flickity('previous');
            });

            // Next
            $('.insurers-next').on('click', function () {
                $(insurersCarousel).flickity('next');
            });
        }


        // Accreditation Logos (Footer)
        if ($('#site-footer .accreditation-carousel').length > 0) {
            $('#site-footer .accreditation-carousel').slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                arrows: false,
                fade: false,
                autoplay: true,
                autoplaySpeed: 0,
                cssEase: 'linear',
                speed: 4000,
                pauseOnHover: false,

                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                        }
                    }
                ]
            });
        }

        // Gallery Carousel
        if ($('.gallery-main-slider').length > 0) {
            $('.gallery-main-slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: false,
                asNavFor: $galleryThumbSlider
            });

            $('.gallery-thumb-slider').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: $galleryMainSlider,
                focusOnSelect: true,
                arrows: false,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3
                        }
                    }
                ]
            });

            // Previous
            $('.gallery-prev').on('click', function () {
                $('.gallery-main-slider').slick('slickPrev');
            });

            // Next
            $('.gallery-next').on('click', function () {
                $('.gallery-main-slider').slick('slickNext');
            });
        }


        // Load & autoplay hero videos on interaction
        let heroVideos = document.querySelector('.hero-iframe');
        if (heroVideos != null) {
            heroAutoplay();
        }

        // Animate on Scroll
        AOS.init({
            // Global options
            offset: 0,
            duration: 1000,
            easing: 'ease-in-out-sine',
            delay: 300,
            // once: true,
        });
        /*
        // Refresh AOS after all images loaded
        document.querySelectorAll("img").forEach(img => {
            img.addEventListener("load", () => {
                AOS.refresh();
            });
        });
        */

    }); // End Document Ready


    // On load
    $(window).on('load', function () {

        // Header bar scrolled
        scrollbarState();

        // Section nav scroll state
        let sectionNav = document.querySelector('.section-nav');
        if (sectionNav != null) {
            sectionNavState()
        }

    });


    // On Scroll
    $(window).on('scroll', function () {

        // Header bar scrolled
        scrollbarState();

        // Section nav scroll state
        let sectionNav = document.querySelector('.section-nav');
        if (sectionNav != null) {
            sectionNavState()
        }

    });


    // On Resize
    $(window).on('resize', function () {

    });


    /***
    ** Functions
    ***/

    // Header bar scrolled
    function scrollbarState() {
        // Header bar height
        var navHeight = $('#site-header').outerHeight();

        // Position of div which trigger header change
        // var scrollChangePoint = $('.scroll-change-point').offset().top;

        if ($(document).scrollTop() > navHeight) {
            $('body').addClass('scrolled');
            $('#site-header').addClass('is-scrolled');
        } else {
            $('body').removeClass('scrolled');
            $('#site-header').removeClass('is-scrolled');
        }
    }

    // Header bar scrolled
    function sectionNavState() {
        var headerHeight = $('.banner').outerHeight();

        // Position of div which trigger header change
        // var scrollChangePoint = $('.scroll-change-point').offset().top;

        if ($(document).scrollTop() > (headerHeight / 2)) {
            $('.section-nav').addClass('is-scrolled');
        } else {
            $('.section-nav').removeClass('is-scrolled');
        }
    }


    // Hero video autoplay on interaction
    function heroAutoplay() {
        let videoLoaded = false;

        function loadVideo() {
            if (!videoLoaded) {
                document.querySelectorAll('.hero-iframe').forEach(function (iframe) {
                    const baseSrc = iframe.getAttribute('data-src');
                    iframe.setAttribute('src', baseSrc + '&autoplay=1');
                    iframe.classList.add('loaded');
                });
                videoLoaded = true;
                // Remove event listeners after first trigger
                events.forEach(event => {
                    document.removeEventListener(event, loadVideo);
                });
            }
        }

        const events = ['mousemove', 'click', 'keydown', 'touchstart'];
        events.forEach(event => {
            document.addEventListener(event, loadVideo, { once: true });
        });
    }


    /*
    $('.launch-video-btn').on('click', function () {

        const targetId = $(this).data('target');
        const $container = $('#' + targetId);

        if (!$container.length) {
            return;
        }

        const $videoWrapper = $container.find('.video-wrapper');
        const $videoContainer = $videoWrapper.find('.video-container');
        const $thumbnail = $videoWrapper.find('.video-thumbnail');
        const $videoInfo = $container.find('.video-info');   // <— text content

        if ($videoContainer.length) {

            // Hide thumbnail + text content, show video
            $thumbnail.addClass('d-none');
            $videoInfo.addClass('d-none');
            $videoContainer.removeClass('d-none');

            // Optional: autoplay
            const $iframe = $videoContainer.find('iframe');
            if ($iframe.length) {
                const src = $iframe.attr('src');
                $iframe.attr('src', src + '&autoplay=1');
            }
        }
    });
    */


    // end jQuery wrapper
})(jQuery);
